import { useState } from "react";
import Layout from "@/components/Layout";
import { API_BASE } from "@/lib/api";
import { Download, FileSpreadsheet, FileText, Calendar, Users, Truck, MapPin, AlertTriangle, TrendingUp } from "lucide-react";

const REPORTES = [
  { key: "entregas-sla", icon: TrendingUp, title: "Entregas y SLA", desc: "Cumplimiento de plazos (24h / 48h / +48h) global." },
  { key: "por-cliente", icon: Users, title: "Por Cliente / Aliado", desc: "KPIs de cada aliado — total, entregados, % éxito." },
  { key: "por-repartidor", icon: Truck, title: "Por Repartidor", desc: "Productividad, entregas y no entregas por repartidor." },
  { key: "por-comuna", icon: MapPin, title: "Por Comuna / Zona", desc: "Distribución geográfica y desempeño por comuna." },
  { key: "incidencias", icon: AlertTriangle, title: "Incidencias", desc: "No entregados con motivos frecuentes y destino." },
];

export default function AdminReportes() {
  const [fro, setFro] = useState("");
  const [to, setTo] = useState("");

  const download = (key, format) => {
    const token = localStorage.getItem("voycargo_token");
    const q = new URLSearchParams({ format });
    if (fro) q.set("fro", fro);
    if (to) q.set("to", to);
    fetch(`${API_BASE}/reports/${key}?${q.toString()}`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => r.blob())
      .then((b) => {
        const url = URL.createObjectURL(b);
        const a = document.createElement("a");
        a.href = url;
        a.download = `voycargo-${key}.${format === "excel" ? "xlsx" : "pdf"}`;
        a.click();
      });
  };

  return (
    <Layout>
      <div className="mb-8">
        <div className="font-mono-tech text-xs text-yellow-300 uppercase tracking-widest mb-2">/ Business Intelligence</div>
        <h1 className="font-display font-black text-4xl md:text-5xl tracking-tighter">Reportes</h1>
        <p className="text-zinc-400 mt-3 max-w-2xl">Exportables en Excel o PDF. Filtra por rango de fechas o descarga el histórico completo.</p>
      </div>

      <div className="border border-white/10 bg-zinc-900/40 p-6 mb-8 flex flex-wrap items-end gap-4">
        <div className="flex items-center gap-2 text-zinc-400 text-xs font-mono-tech uppercase tracking-widest">
          <Calendar className="w-3.5 h-3.5" /> Rango
        </div>
        <div>
          <label className="block text-[10px] font-mono-tech uppercase tracking-widest text-zinc-500 mb-1">Desde</label>
          <input type="date" value={fro} onChange={(e) => setFro(e.target.value)} className="bg-transparent border border-white/20 focus:border-yellow-300 outline-none px-3 py-2 text-sm font-mono-tech" data-testid="date-from" />
        </div>
        <div>
          <label className="block text-[10px] font-mono-tech uppercase tracking-widest text-zinc-500 mb-1">Hasta</label>
          <input type="date" value={to} onChange={(e) => setTo(e.target.value)} className="bg-transparent border border-white/20 focus:border-yellow-300 outline-none px-3 py-2 text-sm font-mono-tech" data-testid="date-to" />
        </div>
        <button onClick={() => { setFro(""); setTo(""); }} className="text-xs font-mono-tech text-zinc-500 hover:text-yellow-300 uppercase tracking-widest">Limpiar</button>
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        {REPORTES.map((r) => (
          <div key={r.key} className="border border-white/10 bg-zinc-900/40 p-6 hover:border-yellow-300/40 transition-colors" data-testid={`report-card-${r.key}`}>
            <div className="flex items-start justify-between mb-4">
              <r.icon className="w-6 h-6 text-yellow-300" strokeWidth={1.5} />
              <span className="font-mono-tech text-[10px] uppercase tracking-widest text-zinc-500">/ {r.key}</span>
            </div>
            <div className="font-display font-black text-2xl tracking-tighter mb-2">{r.title}</div>
            <p className="text-zinc-400 text-sm mb-6">{r.desc}</p>
            <div className="flex gap-2">
              <button onClick={() => download(r.key, "excel")} data-testid={`download-${r.key}-excel`} className="flex-1 bg-yellow-300 text-black font-bold py-2.5 uppercase tracking-widest text-xs hover:bg-yellow-200 inline-flex items-center justify-center gap-2">
                <FileSpreadsheet className="w-3.5 h-3.5" /> Excel
              </button>
              <button onClick={() => download(r.key, "pdf")} data-testid={`download-${r.key}-pdf`} className="flex-1 border border-white/20 hover:border-yellow-300 font-bold py-2.5 uppercase tracking-widest text-xs inline-flex items-center justify-center gap-2">
                <FileText className="w-3.5 h-3.5" /> PDF
              </button>
            </div>
          </div>
        ))}
      </div>
    </Layout>
  );
}
